import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DesignSystemModule } from '@inyova/design-system';
import { InyovaSharedModule } from '@inyova/inyova-shared';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';

import * as fromComponents from './components';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DesignSystemModule, TranslateModule, InyovaSharedModule, QRCodeComponent],
  declarations: [...fromComponents.components],
  exports: [...fromComponents.components]
})
export class AccountCommonModule {}
